"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.domRectToSelectionRectangle = void 0;
exports.domRectToSelectionRectangle = function (rectangle, region) {
    var regionDomRect = region.getBoundingClientRect();
    var regionId = region.getAttribute('data-region-selector-id');
    return __assign({ top: rectangle.y - regionDomRect.y, left: rectangle.x - regionDomRect.x, width: rectangle.width, height: rectangle.height }, (regionId ? { regionId: regionId } : {}));
};
//# sourceMappingURL=TextSelection.js.map